<template>
	<div class="chart">
		<div class="item">
			<div class="flex-item">
				<div class="title">平均成交天数</div>
				<div class="val">23</div>
			</div>
			<div class="flex-item">
				<div class="title">平均跟进次数</div>
				<div class="val">23</div>
			</div>
		</div>
		<div class="charts">
			<BaseChart :option="baseOption" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LeadTransactionCycle',
		props: {
			xData: {
				type: Array,
				default: () => [],
			},
			barData: {
				type: Array,
				default: () => [],
			},
		},
		computed: {
			baseOption() {
				return {
					grid: {
						bottom: '13%',
						right: '5%',
						top: '13%',
						left: '5%',
					},
					tooltip: {
						trigger: 'axis',
					},
					legend: {
						show: false,
						data: ['成交数'],
						bottom: '2%',
						itemWidth: 14,
						itemGap: 60,
					},
					xAxis: [
						{
							type: 'category',
							data: ['7天内', '8-15天', '15-30天', '1-2个月', '2-3个月', '3个月以上'],
							splitLine: {
								show: true,
								lineStyle: { type: 'dashed' },
							},
						},
					],
					yAxis: {
						type: 'value',
						splitLine: {
							lineStyle: { type: 'dashed' },
						},
					},
					series: [
						{
							name: '成交数',
							type: 'line',
							smooth: true,
							showSymbol: false,
							color: '#4080FF',
							data: [12, 5, 6, 33, 10, 8],
						},
					],
				};
			},
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.chart {
		width: 100%;
		height: 100%;
	}
	.item {
		height: 80px;
		display: flex;
		gap: 20px;
	}
	.flex-item {
		padding: 13px;
		box-sizing: border-box;
		flex: 1;
		height: 69px;
		background: #fff7ed;
		border-radius: 8px;
		border: 1px solid #ffedd5;
	}
	.title {
		color: #f97316;
		font-weight: 500;
		font-size: 14px;
	}
	.val {
		margin-top: 7px;
		margin-bottom: 10px;
		font-weight: bold;
		font-size: 20px;
		color: #0f172a;
	}
	.charts {
		height: calc(100% - 80px);
	}
</style>
